import { useSwitchState } from '../../../hooks/useSwitchState';
import { getDeviceIdsByLocationData } from '../../../helpers/helpers';

/**
 * Every device id of each system, for settings that go to all devices. TGS
 * and TES share the blowers, so `blowers` is their union. Returns a getter
 * so the ids are read when the setting is sent.
 */
export const useSettingsDeviceIds = () => {
  const { flat: flatEss } = useSwitchState('ess');
  const { flat: flatTgs } = useSwitchState('tgs');
  const { flat: flatTes } = useSwitchState('tes');

  return () => {
    const ess = getDeviceIdsByLocationData(flatEss);
    const tgs = getDeviceIdsByLocationData(flatTgs);
    const tes = getDeviceIdsByLocationData(flatTes);
    return { ess, tgs, tes, blowers: [...new Set([...tgs, ...tes])] };
  };
};
